import ReactDOM from 'react-dom/client'
import * as Sentry from "@sentry/react";
import App from './App.jsx'
import './styles/index.css'
import { migrateStorage } from './utils/userData'
import { initMixpanel } from './utils/mixpanel'

if (!import.meta.env.DEV) {
  Sentry.init({
    dsn: "https://b4586e09d420eae261a8c2b764fda473@o4510826238509056.ingest.de.sentry.io/4510826244472912",
    sendDefaultPii: true,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration()
    ],
    tracesSampleRate: 1.0,
    tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    enableLogs: true
  });
}

// Migrate legacy auth tokens to unified token key on app start
migrateStorage()
initMixpanel()

ReactDOM.createRoot(document.getElementById('root')).render(
  // <React.StrictMode>
    <App />
  // </React.StrictMode>,
)

